import { ULandingSection } from './../.nuxt/components.d'
export default defineAppConfig({
    ui: {
        strategy: 'override',

        safelistColors: ['green'],

        primary: 'green',

        container: {
            base: 'mx-auto',
            padding: 'px-4 sm:px-6 lg:px-4',
            constrained: 'max-w-7xl'
        },

        header: {
            wrapper: 'bg-dark-950 p-2 -mb-px sticky top-0 z-50',
            container: 'flex items-center justify-between gap-3 h-[--header-height]',
            left: 'lg:flex-1 flex items-center gap-1.5',
            center: '',
            right: 'flex items-center justify-end lg:flex-1 gap-1.5',
            logo: 'flex-shrink-0 font-bold text-xl text-gray-900 dark:text-white flex items-end gap-1.5',
            panel: {
                wrapper: 'fixed inset-0 z-50 overflow-y-auto bg-background lg:hidden',
                header: 'px-4 sm:px-6',
                body: 'px-4 sm:px-6 pt-3 pb-6'
            },
            button: {
                base: 'lg:hidden text-white rounded-md p-2 bg-green-500 hover:text-white hover:bg-blue-700',
                icon: {
                    open: 'i-bi-justify',
                    close: 'i-bi-x'
                }
            },
            links: {
                wrapper: 'flex items-center gap-x-5',
                base: 'text-base font-semibold flex items-center',
                active: 'text-green-600',
                inactive: 'text-blue-600 hover:text-green-600',
                trailingIcon: {
                    name: 'i-bi-chevron-down',
                    base: 'w-3 h-3 ms-1 transform transition-transform duration-200 flex-shrink-0',
                    active: 'rotate-180',
                    inactive: ''
                },
                externalIcon: {
                    name: 'i-bi-chevron-down',
                    base: 'w-3 h-3 absolute top-0.5 -right-3.5 text-gray-400 dark:text-gray-500'
                },
                default: {
                    popover: {
                        mode: 'hover',
                        openDelay: 0,
                        ui: {
                            width: 'max-w-[16rem]'
                        }
                    }
                }
            },
            popover: {
                links: {
                    wrapper: 'p-2 space-y-2 bg-white',
                    base: 'block px-2 py-1.5 rounded-md flex items-start gap-1.5',
                    active: 'bg-gray-100 text-green-600 dark:text-white',
                    inactive: 'text-blue-600 hover:bg-gray-100 dark:hover:bg-gray-800',
                    label: 'font-semibold text-sm inline-block relative',
                    description: 'text-xs text-gray-500 dark:text-gray-400 line-clamp-2',
                    icon: {
                        base: 'w-5 h-5 flex-shrink-0 mt-1 me-1 text-green-600'
                    },
                    externalIcon: {
                        name: 'i-heroicons-arrow-up-right-20-solid',
                        base: 'w-3 h-3 absolute top-0.5 -right-3.5 text-gray-400 dark:text-gray-500'
                    }
                }
            }
        },

        // verticalNavigation: {
        //     wrapper: 'border-s border-gray-200 dark:border-gray-800 space-y-2',
        //     base: 'group relative flex items-center border-s -ms-px leading-6 before:hidden',
        //     padding: 'py-2 ps-4',
        //     rounded: '',
        //     font: 'text-xl font-semibold',
        //     ring: '',
        //     active: 'text-green-600 dark:text-green-600 border-current font-semibold',
        //     inactive:
        //         'border-transparent hover:border-gray-400 dark:hover:border-gray-500 text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-300',
        //     label: 'truncate relative',
        //     icon: {
        //         base: 'flex-shrink-0 w-6 h-6 relative top-1 -left-2',
        //         active: 'text-green-600 dark:text-gray-200',
        //         inactive: 'text-gray-400 dark:text-gray-500 group-hover:text-gray-700 dark:group-hover:text-gray-200'
        //     }
        // },

        breadcrumbs: {
            wrapper: 'relative min-w-0',
            ol: 'flex items-center gap-x-1.5',
            li: 'flex items-center gap-x-1.5 text-gray-500 dark:text-gray-400 text-sm leading-6 min-w-0',
            base: 'flex items-center gap-x-1.5 group font-semibold min-w-0',
            label: 'block truncate',
            icon: {
                base: 'flex-shrink-0 w-5 h-5',
                active: '',
                inactive: ''
            },
            divider: {
                base: 'flex-shrink-0 w-5 h-5 rtl:rotate-180'
            },
            active: 'text-blue-600 dark:text-blue-400',
            inactive: ' hover:text-gray-700 dark:hover:text-gray-200',
            default: {
                divider: 'i-bi-chevron-right'
            }
        },

        accordion: {
            wrapper: 'w-full flex flex-col',
            container: 'w-full flex flex-col',
            item: {
                base: 'text-left',
                size: 'text-xs',
                color: 'text-gray-600 dark:text-gray-400',
                padding: 'p-3',
                icon: 'ms-auto transform transition-transform duration-200'
            },
            transition: {
                enterActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out',
                leaveActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out'
            },
            default: {
                openIcon: 'i-bi-plus',
                closeIcon: 'i-bi-minus',
                class: 'mb-0 w-full font-semibold text-gray-700 hover:bg-white bg-white ring-0 rounded-md dark:text-gray-400',
                variant: 'soft'
            }
        },

        avatar: {
            text: 'font-medium leading-none text-xs text-gray-900 dark:text-white truncate'
        },

        card: {
            base: '',
            background: 'bg-white dark:bg-gray-900',
            divide: 'divide-y divide-gray-200 dark:divide-gray-800',
            ring: 'ring-1 ring-gray-200 dark:ring-gray-800',
            rounded: 'rounded-md',
            shadow: 'shadow-none',
            body: {
                base: '',
                background: '',
                padding: 'px-4 py-3 sm:px-4'
            },
            header: {
                base: '',
                background:
                    'rounded-t-md border-t-4 border-gray-300 border-t-success-500 dark:border-gray-800 dark:border-t-success-500 dark:bg-gray-800',
                padding: 'px-4 py-3 sm:px-4'
            },
            footer: {
                base: '',
                background: '',
                padding: 'px-4 py-3 sm:px-4'
            }
        },

        footer: {
            wrapper: 'relative text-xs text-white pb-4',
            top: {
                wrapper: '',
                container: 'py-8 md:py-8'
            },
            bottom: {
                wrapper: '',
                container: 'py-8 lg:py-4 lg:flex lg:items-center lg:justify-between lg:gap-x-3',
                left: 'flex items-center justify-center lg:justify-start lg:flex-1 gap-x-1.5 mt-3 lg:mt-0 lg:order-1',
                center: 'mt-3 lg:mt-0 lg:order-2 flex items-center justify-center',
                right: 'flex items-center justify-center gap-x-1.5 lg:flex-1 lg:justify-end lg:order-3'
            },
            columns: {
                wrapper: 'xl:grid xl:grid-cols-3 xl:gap-0 py-8',
                left: 'text-sm text-white text-center md:text-left mb-10 xl:mb-0',
                center: 'flex flex-col text-center md:grid grid-flow-col auto-cols-fr gap-8 xl:col-span-2',
                right: 'mt-10 xl:mt-0',
                label: 'text-base font-semibold text-white dark:text-white',
                list: 'mt-6 space-y-1',
                base: 'text-sm relative hover:text-green-600 dark:hover:text-green-600',
                active: 'text-green-500 dark:text-green-500 font-medium',
                inactive: 'text-white hover:text-green-600',
                externalIcon: {
                    name: 'i-bi-arrow-up-right',
                    base: 'w-2 h-2 absolute top-0.5 -right-3.5 text-gray-400 dark:text-gray-500'
                }
            }
        },

        button: {
            base: 'uppercase focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 flex-shrink-0',
            font: 'font-semibold',
            rounded: 'rounded-md',
            size: {
                '2xs': 'text-xs',
                xs: 'text-xs',
                sm: 'text-sm',
                md: 'text-sm',
                lg: 'text-sm',
                xl: 'text-base',
                '2xl': 'text-xl'
            },
            gap: {
                '2xs': 'gap-x-1',
                xs: 'gap-x-1.5',
                sm: 'gap-x-1.5',
                md: 'gap-x-2',
                lg: 'gap-x-2.5',
                xl: 'gap-x-2.5',
                '2xl': 'gap-x-3'
            },
            padding: {
                '2xs': 'px-2 py-1',
                xs: 'px-2.5 py-1.5',
                sm: 'px-2.5 py-1.5',
                md: 'px-3 py-2',
                lg: 'px-3.5 py-2.5',
                xl: 'px-3.5 py-2.5',
                '2xl': 'px-4 py-3'
            },
            square: {
                '2xs': 'p-1',
                xs: 'p-1.5',
                sm: 'p-1.5',
                md: 'p-2',
                lg: 'p-2.5',
                xl: 'p-2.5',
                '2xl': 'p-3'
            },
            color: {
                landing: {
                    solid: 'shadow-sm ring-1 ring-inset ring-green-950 text-green-950 hover:bg-green-950 hover:bg-green-900 text-white bg-green-950 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-green-900 duration-300',
                    outline:
                        'shadow-sm ring-1 ring-inset ring-green-950 text-green-950 hover:bg-green-900 hover:ring-green-900 hover:text-white bg-transparent disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-green-900 duration-300'
                },
                green: {
                    solid: 'shadow-sm ring-1 ring-inset ring-green-600 text-green-600 hover:bg-green-600 hover:bg-green-500 text-white bg-green-600 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-green-500 duration-300',
                    outline:
                        'shadow-sm ring-1 ring-inset ring-green-600 text-green-600 hover:bg-green-500 hover:ring-green-500 hover:text-white bg-transparent disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-green-500 duration-300'
                },
                blue: {
                    solid: 'shadow-sm ring-1 ring-inset ring-blue-600 text-blue-600 hover:bg-blue-600 hover:bg-blue-500 text-white bg-blue-600 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-blue-500 duration-300',
                    outline:
                        'shadow-sm ring-1 ring-inset ring-blue-600 text-blue-600 hover:bg-blue-500 hover:ring-blue-500 hover:text-white bg-transparent disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-blue-500 duration-300'
                },
                gold: {
                    solid: 'shadow-sm ring-1 ring-inset ring-gold-500 text-gold-500 hover:bg-gold-500 hover:bg-gold-400 text-white bg-gold-500 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-gold-400 duration-300',
                    outline:
                        'shadow-sm ring-1 ring-inset ring-gold-500 text-gold-500 hover:bg-gold-400 hover:ring-gold-400 hover:text-white bg-transparent disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-gold-400 duration-300'
                },
                apple: {
                    solid: 'shadow-sm ring-1 ring-inset ring-apple-950 text-apple-950 hover:bg-apple-950 hover:bg-apple-900 text-white bg-apple-950 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-apple-500 duration-300',
                    outline:
                        'shadow-sm ring-1 ring-inset ring-apple-950 text-apple-950 hover:bg-apple-950 hover:ring-apple-900 hover:text-white bg-transparent disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-apple-500 duration-300'
                },
                google: {
                    solid: 'shadow-sm ring-1 ring-inset ring-google-500 text-google-500 hover:bg-google-500 hover:bg-google-500 text-white bg-google-500 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-google-500 duration-300',
                    outline:
                        'shadow-sm ring-1 ring-inset ring-google-500 text-google-500 hover:bg-google-500 hover:ring-google-500 hover:text-white bg-transparent disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-google-500 duration-300'
                },
                facebook: {
                    solid: 'shadow-sm ring-1 ring-inset ring-facebook-500 text-facebook-500 hover:bg-facebook-500 hover:bg-facebook-500 text-white bg-facebook-500 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-facebook-500 duration-300',
                    outline:
                        'shadow-sm ring-1 ring-inset ring-facebook-500 text-facebook-500 hover:bg-facebook-500 hover:ring-facebook-500 hover:text-white bg-transparent disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-facebook-500 duration-300'
                }
            },
            icon: {
                base: 'flex-shrink-0',
                loading: 'animate-spin',
                size: {
                    '2xs': 'h-4 w-4',
                    xs: 'h-4 w-4',
                    sm: 'h-5 w-5',
                    md: 'h-5 w-5',
                    lg: 'h-5 w-5',
                    xl: 'h-6 w-6',
                    '2xl': 'h-7 w-7'
                }
            },
            default: {
                size: 'lg',
                variant: 'solid',
                color: 'green',
                loadingIcon: 'i-eos-icons:loading'
            }
        },

        buttonGroup: {
            shadow: 'shadow-none',
            orientation: {
                'rounded-md': {
                    horizontal: {
                        start: 'rounded-s-md',
                        end: 'rounded-e-md'
                    }
                }
            }
        },

        formGroup: {
            wrapper: 'mb-0', // 'mb-4'
            label: {
                base: 'text-dark-950 dark:text-gray-200 text-sm font-normal'
            },
            help: 'mt-2 font-normal text-xs text-gray-500 dark:text-gray-400',
            error: 'mt-1 font-normal text-xs text-danger-500 dark:text-danger-400',
            default: {
                size: 'xs'
            }
        },

        input: {
            icon: {
                trailing: {
                    wrapper: 'absolute inset-y-0 end-0 flex items-center z-20',
                    pointer: 'cursor-pointer'
                }
            }
        },

        table: {
            tr: {
                base: '',
                selected: 'bg-gray-50 dark:bg-gray-800/50',
                expanded: 'bg-gray-50 dark:bg-gray-800/50',
                active: 'hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer'
            },
            th: {
                base: 'text-left rtl:text-right',
                padding: 'px-4 py-2',
                color: 'text-gray-900 dark:text-white',
                font: 'font-semibold',
                size: 'text-sm'
            },
            td: {
                base: 'whitespace-nowrap',
                padding: 'px-4 py-2',
                color: 'text-gray-500 dark:text-gray-400',
                font: '',
                size: 'text-sm'
            }
        },

        notification: {
            wrapper: 'w-full pointer-events-auto',
            container: 'relative overflow-hidden',
            inner: 'w-0 flex-1',
            title: 'text-sm font-medium text-gray-900 dark:text-white',
            description: 'mt-1 text-sm leading-4 text-gray-500 dark:text-gray-400',
            actions: 'flex items-center gap-2 mt-3 flex-shrink-0',
            background: 'bg-white dark:bg-gray-900',
            shadow: 'shadow-md',
            rounded: 'rounded-md',
            padding: 'p-4',
            gap: 'gap-3',
            ring: 'ring-1 ring-gray-200 dark:ring-gray-800',
            icon: {
                base: 'flex-shrink-0 w-5 h-5',
                color: 'text-{color}-500 dark:text-{color}-400'
            },
            avatar: {
                base: 'flex-shrink-0 self-center',
                size: 'md'
            },
            progress: {
                base: 'absolute bottom-0 end-0 start-0 h-1',
                background: 'bg-{color}-500 dark:bg-{color}-400'
            },
            transition: {
                enterActiveClass: 'transform ease-out duration-300 transition',
                enterFromClass: 'translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2',
                enterToClass: 'translate-y-0 opacity-100 sm:translate-x-0',
                leaveActiveClass: 'transition ease-in duration-100',
                leaveFromClass: 'opacity-100',
                leaveToClass: 'opacity-0'
            },
            default: {
                color: 'success',
                icon: null,
                timeout: 5000,
                closeButton: {
                    icon: 'i-bi-x',
                    color: 'gray',
                    variant: 'link',
                    padded: false
                },
                actionButton: {
                    size: 'xs',
                    color: 'white'
                }
            }
        },

        notifications: {
            wrapper: 'fixed flex flex-col justify-end z-[55]',
            position: 'top-0 right-0',
            width: 'w-full sm:w-96',
            container: 'px-4 sm:px-6 py-6 space-y-3 overflow-y-auto'
        },

        // Nuxt UI Pro theme below

        landing: {
            card: {
                wrapper:
                    'w-[100%] relative group isolate rounded-xl background-gradient ring-1 ring-gray-200 dark:ring-gray-800 before:hidden before:lg:block before:absolute before:-inset-[2px] before:h-[calc(100%+4px)] before:w-[calc(100%+4px)] before:z-[-1] before:rounded-[13px] flex-1 flex flex-col shadow',
                description: 'text-[15px] text-gray-500 dark:text-gray-400 mt-1 truncate'
            },

            section: {
                wrapper: 'py-10 md:py-10',
                title: 'text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl lg:text-4xl',
                description: 'mt-2 text-lg text-gray-600 dark:text-gray-300',
                features: {
                    icon: {
                        base: 'absolute left-0 top-1 h-6 w-6 text-green-600',
                        name: 'i-ph-plant'
                    }
                }
            },

            cta: {
                wrapper: 'relative',
                container: 'text-center',
                body: {
                    base: 'flex flex-col gap-16 sm:gap-y-24',
                    padding: 'py-24 px-5 lg:py-24 lg:px-16'
                },
                title: 'text-3xl font-bold text-gray-900 dark:text-white sm:text-3xl',
                description: 'mt-6 text-lg text-gray-600 dark:text-gray-300',
                links: 'mt-10 flex items-center justify-center gap-x-6'
            },

            faq: {
                wrapper: 'relative w-full divide-y divide-gray-300 dark:divide-gray-800',
                item: {
                    size: 'text-sm',
                    padding: 'py-3'
                },
                button: {
                    base: 'w-full text-left text-base capitalize py-5',
                    label: 'text-gray-900 dark:text-white pr-10 md:pr-10 lg:pr-10',
                    trailingIcon: {
                        name: 'i-bi-chevron-down',
                        base: 'absolute right-0 w-4 h-4 ms-auto transform transition-transform duration-200 flex-shrink-0 mr-1.5',
                        active: '',
                        inactive: '-rotate-90'
                    }
                }
            },

            hero: {
                wrapper: 'py-24 sm:py-32 md:py-40 relative',
                container: 'gap-16 sm:gap-y-24 flex flex-col',
                base: 'text-center',
                headline: 'mb-10',
                title: 'text-5xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-7xl',
                description: 'mt-6 text-lg tracking-tight text-gray-600 dark:text-gray-300',
                links: 'mt-10 flex flex-wrap justify-center gap-x-6 gap-y-3'
            }
        },

        page: {
            card: {
                wrapper: 'relative group',
                to: 'hover:ring-2 hover:ring-primary-500 dark:hover:ring-primary-400 hover:bg-gray-100/50 dark:hover:bg-gray-800/50',
                icon: {
                    wrapper: 'mb-2 flex',
                    base: 'w-10 h-10 flex-shrink-0 text-green-600'
                },
                body: {
                    base: 'flex-1'
                },
                title: 'text-gray-900 dark:text-white text-2xl font-semibold truncate flex items-center gap-1.5',
                description: 'text-[15px] text-gray-500 dark:text-gray-400 mt-1'
            },

            hero: {
                title: 'text-3xl font-bold text-white dark:text-white sm:text-4xl lg:text-5xl',
                description: 'mt-4 text-2xl text-white font-semibold dark:text-gray-400'
            },

            error: {
                wrapper: 'min-h-[calc(100vh-var(--header-height))] flex flex-col items-center justify-center',
                status: 'text-xl font-semibold text-green-600',
                name: 'text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl',
                message: 'mt-6 text-lg text-gray-600 dark:text-gray-400 text-center',
                links: 'mt-10 flex items-center justify-center gap-x-6',
                default: {
                    clearButton: {
                        label: 'Go back home',
                        color: 'green',
                        size: 'lg'
                    }
                }
            }
        },

        // Nuxt UI Pro Admin area below

        dashboard: {
            sidebar: {
                links: {
                    base: 'group relative flex items-center gap-1.5 my-1 px-2.5 py-1.5 w-full rounded-md font-medium text-sm focus:outline-none focus-visible:outline-none dark:focus-visible:outline-none focus-visible:before:ring-inset focus-visible:before:ring-2 focus-visible:before:ring-primary-500 dark:focus-visible:before:ring-primary-400 before:absolute before:inset-px before:rounded-md disabled:cursor-not-allowed disabled:opacity-75',
                    active: 'text-white before:bg-blue-500 dark:text-white dark:before:bg-gray-800',
                    inactive:
                        'text-white/80 hover:text-white before:bg-blue-400 hover:before:bg-blue-500 dark:text-gray-400 dark:hover:text-white dark:hover:before:bg-gray-800/50',
                    icon: {
                        base: 'flex-shrink-0 w-4 h-4 relative',
                        active: 'text-white dark:text-white',
                        inactive: 'text-white/80 group-hover:text-white dark:text-gray-500 dark:group-hover:text-gray-200'
                    },
                    badge: {
                        base: 'flex-shrink-0 ml-auto relative rounded',
                        color: 'success',
                        variant: 'solid',
                        size: 'xs'
                    },
                    label: 'text-sm truncate relative',
                    dot: {
                        wrapper: 'w-px h-full mx-[9.5px] bg-gray-200 dark:bg-gray-700 relative',
                        after: 'after:absolute after:z-[1] after:w-px after:h-full after:bg-gray-200 after:dark:bg-gray-700 after:transform after:translate-y-full',
                        base: 'w-1 h-1 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
                        active: 'bg-white dark:bg-white',
                        inactive: 'bg-white/80 dark:bg-white/80 group-hover:bg-white dark:group-hover:bg-white'
                    }
                }
            },

            card: {
                divide: '',
                header: {
                    base: 'flex flex-wrap items-center justify-between gap-2 border-t border-gray-200 border-b',
                    inner: 'flex items-start gap-4',
                    background:
                        'rounded-t-md border-t-4 border-gray-300 border-t-blue-500 dark:border-gray-800 dark:border-t-blue-500 dark:bg-gray-800',
                    padding: 'px-4 py-4 sm:px-6'
                },
                title: 'text-gray-900 dark:text-white font-semibold',
                description: 'mt-1 text-gray-500 dark:text-gray-400 text-sm',
                links: 'flex flex-wrap items-center gap-1.5',
                icon: {
                    wrapper: 'inline-flex',
                    base: 'w-12 h-12 flex-shrink-0 text-blue-500 dark:text-white'
                }
            }
        },

        navigation: {
            links: {
                wrapper: 'space-y-4',
                wrapperLevel: 'space-y-3',
                base: 'flex items-center gap-1.5 group',
                active: 'text-success-600 font-semibold border-current',
                inactive: 'text-gray-600 hover:text-gray-700',
                level: 'border-l -ml-px pl-4',
                icon: {
                    base: 'w-5 h-5 flex-shrink-0'
                },
                badge: {
                    base: 'rounded-full'
                },
                label: 'text-xl truncate'
            },
            tree: {
                wrapper: 'space-y-4 ',
                accordion: {
                    button: {
                        label: 'text-xl font-semibold truncate',
                        trailingIcon: {
                            name: 'i-bi-chevron-down',
                            base: 'w-5 h-5 ms-auto transform transition-transform duration-200 flex-shrink-0 mr-1.5',
                            active: 'text-gray-600',
                            inactive: 'text-gray-600 group-hover:text-gray-600 -rotate-90'
                        }
                    }
                },
                links: {
                    label: 'text-xl font-semibold text-gray-600 truncate'
                }
            }
        }

        // auth: {
        //     form: {
        //         wrapper: 'w-full max-w-sm space-y-6',
        //         base: 'text-center',
        //         container: 'gap-y-6 flex flex-col',
        //         title: 'text-2xl text-dark-950 dark:text-white font-bold',
        //         description: 'text-sm text-dark-800 dark:text-gray-400 mt-1',
        //         icon: {
        //             wrapper: 'mb-2 pointer-events-none',
        //             base: 'w-16 h-16 flex-shrink-0 text-dark-950 dark:text-white'
        //         },
        //         providers: 'space-y-3',
        //         form: 'space-y-6',
        //         footer: 'text-xs text-gray-500 dark:text-gray-400 mt-2 text-center',
        //         default: {
        //             submitButton: {
        //                 label: 'Continue'
        //             }
        //         }
        //     }
        // }
    }
})
